import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  groupNameData: null,
  profileNameData: null,
  mediaTabData:null,
  commentFocus:null,
  commentSectionFocus:false,
  blockedUserIds: [] as string[]
};

const utilsSlice = createSlice({
  name: 'utilsData',
  initialState,
  reducers: {
    setGroupNameData: (state, action) => {
      state.groupNameData = action.payload.groupNameData;
    },
    setProfileNameData: (state, action) => {
      state.profileNameData = action.payload.profileNameData;
    },
    setMediaTabData: (state, action) => {
      state.mediaTabData = action.payload.mediaTabData;
    },
    setCommentFocus: (state, action) => {
      state.commentFocus = action.payload.commentFocus;
    },
    setCommentSectionFocus:(state, action) => {
      state.commentSectionFocus = action.payload.commentSectionFocus;
    },
    addBlockedUserId: (state, action) => {
      if (action.payload && !state.blockedUserIds.includes(action.payload)) {
        state.blockedUserIds.push(action.payload);
      }
    },
    clearMediaTabData: () => {
      return {
        ...initialState,
        mediaTabData: null
      };
    }
  }
});

export const { setGroupNameData, setProfileNameData, setMediaTabData, clearMediaTabData, setCommentFocus, setCommentSectionFocus, addBlockedUserId} = utilsSlice.actions;

export default utilsSlice.reducer;
